export const formatBytes = (bytes: number): string => {
    const marker = 1024;
    const decimal = 1;
    const kiloBytes = marker; // One KB is 1024 bytes
    const megaBytes = marker * marker; // One MB is 1024 KB
    const gigaBytes = marker * marker * marker; // One GB is 1024 MB

    // return bytes if less than a KB
    if (bytes < kiloBytes) {
        return `${bytes} Bytes`;
    }
    // return KB if less than a MB
    if (bytes < megaBytes) {
        return `${(bytes / kiloBytes).toFixed(decimal)} KB`;
    }
    // return MB if less than a GB
    if (bytes < gigaBytes) {
        return `${(bytes / megaBytes).toFixed(decimal)} MB`;
    }
    // return GB if less than a TB
    return `${(bytes / gigaBytes).toFixed(decimal)} GB`;
};
